<template>
    <div v-role="'func'">
      <br>
      <div>
        <div class="formPosition">
          <!-- Cartão principal contendo a tabela de facturas duplicadas -->
          <v-card style="margin:auto;" width="1220">
            <!-- Barra de progresso exibida durante carregamentos -->
            <v-progress-linear v-if="progresso" indeterminate color="green" height="10"></v-progress-linear>
  
            <!-- Título do cartão -->
            <v-card-title>
              <span>Facturas Duplicadas</span>
            </v-card-title>
  
            <!-- Tabela de facturas duplicadas -->
            <v-data-table :headers="headers" :items="facturasDuplicadas" :search="searchInDb">
              <!-- Coluna de índice (posição da factura na lista) -->
              <template v-slot:item.index="{ item }">
                <span>{{ facturasDuplicadas.indexOf(item) + 1 }}</span>
              </template>
  
              <!-- Coluna formatada: Valor a Pagar -->
              <template v-slot:item.valorAPagar="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.valorAPagar) }}</span>
              </template>
  
              <!-- Coluna formatada: Valor Pago -->
              <template v-slot:item.valorPago="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.valorPago) }}</span>
              </template>
  
              <!-- Coluna formatada: Desconto -->
              <template v-slot:item.desconto="{ item }">
                <span>{{ utilitarios.IntegerToMoneyValueFatura(item.desconto) }}</span>
              </template>
  
              <!-- Coluna de ações (menu com opções) -->
              <template v-slot:item.action="{ item }">
                <v-menu :offset-x="offsetX" :offset-y="offsetY" bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                      <v-icon dark>menu</v-icon>
                    </v-btn>
                  </template>
  
                  <!-- Lista de ações disponíveis -->
                  <v-list>
                    <v-list-item v-if="funcaoPorROle.verificarFuncao(24)" @click="deleteFactura(item)">
                      <v-icon color="red">delete</v-icon> Anular Factura
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '@/plugins/axios'
  import utilitarios from '@/plugins/utilitarios'
  import funcaoPorROle from '@/utilitarios/funcao.untilitario'
  import Swal from 'sweetalert2'
  const ls = require('local-storage')
  
  export default {
    data: () => ({
      funcaoPorROle: funcaoPorROle,
      progresso: false,
      facturasDuplicadas: [],
      headers: [
        { text: '#', value: 'index' },
        { text: 'Factura', value: 'numeroDocumento' },
        { text: 'Estudante', value: 'cliente' },
        { text: 'Matricula', value: 'matricula' },
        { text: 'Emolumento', value: 'produto' },
        { text: 'F. Pagamento', value: 'tpaRef' },
        { text: 'Valor A Pagar', value: 'valorAPagar' },
        { text: 'Valor Pago', value: 'valorPago' },
        { text: 'Desconto', value: 'desconto' },
        { text: 'Autor(a)', value: 'nomeUsuario' },
        { text: 'Data', value: 'data_compra' },
        { text: 'Opção', value: 'action' }
      ],
      utilitarios: utilitarios
    }),
  
    computed: {
      // Recupera o nome do usuário logado do localStorage
      loggedUserName() {
        return ls.get('nomeUsuario')
      }
    },
  
    created() {
      this.initialize()
    },
  
    methods: {
      // Função de inicialização: Carrega facturas duplicadas do servidor
      async initialize() {
        this.progresso = true
        try {
          // Faz a requisição para obter as facturas duplicadas
          this.facturasDuplicadas = await axios.get('/getFaturasDuplicadasAll').then(res => res.data);
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.progresso = false
        }
      },
  
      // Função para deletar uma factura
      async deleteFactura(factura) {
        this.progresso = true
  
        // Conteúdo HTML do alerta de confirmação
        let htmlContent = `
        <p style="text-align: center;"><strong style="color: red;">OBS:</strong> O nome do autor da anulação e a data da anulação serão armazenados.</p>
        <div style="width: 90%; margin: 10 auto;">
          <div style="display: grid; grid-template-columns: 150px auto;">
            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${factura.cliente}</div>
            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Factura:</strong></div>
            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${factura.numeroDocumento}</div>
            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data:</strong></div>
            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${factura.data_compra}</div>
            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Valor pago:</strong></div>
            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(factura.valorPago)}</div>
            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Desconto:</strong></div>
            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(factura.desconto)}</div>
            <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Atendido(a) por:</strong></div>
            <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${factura.nomeUsuario}</div>
          </div>
        </div>
        `;
  
        try {
          // Exibe alerta de confirmação antes de excluir a factura
          Swal.fire({
            title: "Eliminar Factura",
            html: htmlContent,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Finalizar",
            reverseButtons: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              // Parâmetros a serem enviados para a exclusão
              let params = {
                pkVenda: factura.pkVenda,
                autor: this.loggedUserName,
                matricula: factura.matricula,
                numeroDocumento: factura.numeroDocumento,
                valorPago: factura.valorPago,
                valorAPagar: factura.valorAPagar,
                desconto: factura.desconto,
                cliente: factura.cliente,
                data: factura.data_compra,
                fkUsuario: factura.fkUsuario
              }
  
              // Tenta realizar a exclusão via requisição ao backend
              try {
                let result = await axios.post("/deleteFacturasDuplicadas", params).then((res) => res.data);
                if (result[0].last_insert_id >= 1) {
                  Swal.fire('Informação', 'factura eliminada com sucesso!', 'success');
                  this.initialize(); // Recarrega a lista de facturas
                }
              } catch (error) {
                Swal.fire('Informação', 'Erro ao eliminar factura!', 'error');
              }
            }
          });
        } catch (error) {
          Swal.fire('Informação', 'Erro ao eliminar factura!', 'error');
        } finally {
          this.progresso = false; // Oculta a barra de progresso ao finalizar
        }
      }
    }
  }
  </script>
  
  <style scoped>
  /* Estilos específicos para os botões */
  .btn_space {
    margin-bottom: 5px;
  }
  
  .btn_add_align {
    margin-top: 10px;
  }
  </style>
  